/*
  Dispara o evento "form_start" no dataLayer (GTM/GA4) assim que a pessoa
  começa a preencher o formulário de contato (#form-contato) — primeiro
  campo em foco, uma única vez por carregamento de página.

  "generate_lead" (envio do formulário) não precisa de código: no GTM é
  o trigger nativo "Form Submission" apontando pra #form-contato — ver
  conversa sobre a configuração do GTM.

  Não depende do GTM estar instalado: window.dataLayer é criado aqui caso
  ainda não exista, do mesmo jeito que o próprio snippet do GTM faz — se
  o GTM for instalado depois (ver <head> de index.html), ele reaproveita
  esse array normalmente, sem duplicar nada.
*/
(function () {
    var form = document.getElementById('form-contato');
    if (!form) return;

    window.dataLayer = window.dataLayer || [];

    form.addEventListener('focusin', function () {
        window.dataLayer.push({ event: 'form_start' });
    }, { once: true });
})();
